import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomMaterialModule } from './modules/custom-material/custom-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { WhyDiComponent } from './modules/components/why-di/why-di.component';
import { ProfileUploaderComponent } from './modules/components/profile-uploader/profile-uploader.component';
import { AddMasterRequestsComponent } from './modules/components/add-master-requests/add-master-requests.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AccessDeniedDirectLinkComponent } from './modules/components/AccessDeniedDirectLink/AccessDeniedDirectLink';
import { MatDialogModule } from '@angular/material/dialog';
import { SharePopupComponent } from './modules/components/share-popup/share-popup.component';
import { PostViewerComponent } from './modules/components/post-viewer/post-viewer.component';

@NgModule({
  declarations: [
    WhyDiComponent,
    ProfileUploaderComponent,
    AccessDeniedDirectLinkComponent,
    AddMasterRequestsComponent,
    SharePopupComponent,
    PostViewerComponent
  ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SwiperModule,
    MatFormFieldModule,
    MatInputModule,
    PerfectScrollbarModule,
    MatDialogModule,
  ],
  exports: [
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    WhyDiComponent,
    ProfileUploaderComponent,
    AddMasterRequestsComponent,
    PerfectScrollbarModule,
    MatFormFieldModule,
    MatInputModule,
    SharePopupComponent
  ],
  providers: [
  ]

})
export class SharedModule { }
